var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 81,
    viewBox: "0 0 85 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8827 70.0296C38.8827 70.0296 42.5657 46.7478 46.1961 38.277C43.0918 36.567 42.7762 35.0412 42.7762 34.1993C42.8025 33.0681 45.0123 31.2793 46.3802 31.516C47.7482 31.7528 48.59 33.91 48.7479 34.4098C51.7995 32.1737 56.64 33.3312 60.4809 31.6738C60.0337 32.9629 59.1655 33.3575 59.1655 33.3575C59.1655 33.3575 61.7436 33.91 65.111 33.226C65.3477 34.3572 63.7429 34.9622 63.7429 34.9622C63.7429 34.9622 66.6894 35.8567 69.0307 37.5141C69.0044 34.9886 69.7936 34.6729 70.8459 34.5414C71.8981 34.4098 75.0287 36.1724 74.8183 38.198C74.6078 40.2237 72.2665 39.5923 72.2665 41.2233C72.2665 42.8544 70.7933 62.0849 68.0047 74.9228",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9069 36.3303C45.9069 36.3303 45.6438 35.0149 46.9592 34.7256",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6093 37.4613C70.6093 37.4613 72.0035 38.0928 71.872 39.224",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3493 29.2799C59.9547 29.2799 57.8765 26.3072 59.1129 25.3338C60.1389 24.5183 60.8491 25.7021 60.8491 25.7021C60.8491 25.7021 62.2171 24.755 62.717 26.0704C63.2168 27.4647 60.7176 29.2799 60.3493 29.2799Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6395 47.7315C62.8207 46.1144 60.9893 44.5818 58.5492 44.3085C56.109 44.0352 53.984 45.1247 53.8028 46.7419C53.6217 48.359 55.4531 49.8915 57.8933 50.1648C60.3335 50.4381 62.4584 49.3487 62.6395 47.7315Z",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2498 43.1733C64.3992 42.4475 64.0357 41.7594 63.438 41.6364C62.8403 41.5134 62.2347 42.002 62.0853 42.7278C61.9359 43.4536 62.2993 44.1417 62.8971 44.2647C63.4948 44.3877 64.1005 43.8991 64.2498 43.1733Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1424 42.2548C56.1835 41.5149 55.7229 40.8877 55.1136 40.8539C54.5043 40.82 53.9771 41.3924 53.936 42.1323C53.8949 42.8721 54.3555 43.4993 54.9648 43.5332C55.5741 43.567 56.1013 42.9947 56.1424 42.2548Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3236 47.3003C58.3236 47.3003 56.7189 45.8008 57.1924 45.4588C57.6659 45.1168 59.6916 45.564 59.8231 45.8271C59.9283 46.0901 59.0339 47.0372 58.3236 47.3003Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1396 48.2737C58.1396 48.2737 58.35 47.3267 58.3763 46.6953",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1132 48.2738C57.9027 48.4842 56.64 48.8525 56.1665 47.8002",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1133 48.2473C58.3238 48.4314 59.4024 49.0891 60.2705 48.2999",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0362 45.4063C52.6464 45.4063 53.1411 44.9116 53.1411 44.3014C53.1411 43.6912 52.6464 43.1965 52.0362 43.1965C51.4259 43.1965 50.9313 43.6912 50.9313 44.3014C50.9313 44.9116 51.4259 45.4063 52.0362 45.4063Z",
    fill: "#F9C7C1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.427 47.3531C65.0372 47.3531 65.5319 46.8584 65.5319 46.2482C65.5319 45.638 65.0372 45.1433 64.427 45.1433C63.8168 45.1433 63.3221 45.638 63.3221 46.2482C63.3221 46.8584 63.8168 47.3531 64.427 47.3531Z",
    fill: "#F9C7C1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0652 70.7139C44.0652 70.7139 46.8275 51.2203 57.1399 53.0091C67.4523 54.798 62.5854 73.9496 62.5854 73.9496",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5885 68.0041C53.5096 68.3461 53.7464 68.7144 54.0884 68.7933C54.4303 68.8722 54.7986 68.6355 54.8776 68.2935",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8831 23.7108L42.9503 17.2891L33.8653 69.5394L70.7982 75.961L79.8831 23.7108Z",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0006 20.6084L40.1218 12.979L29.748 72.6417L73.6268 80.2711L84.0006 20.6084Z",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9109 59.6122L10.7337 61.9535L4.91986 9.26034L42.1707 5.15646L43.1441 13.4169",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3847 63.4794L7.65572 66.1102L1 5.89309L45.2749 1L46.7218 13.8642",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5748 25.4657C14.7323 24.0188 16.2318 23.2558 18.0733 23.3348",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0735 23.3347C18.0209 22.7823 18.547 22.0194 19.0468 21.8089C19.573 21.5984 20.1254 22.1509 20.1517 22.7034C20.178 23.2558 19.836 23.8609 19.494 24.3344",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5203 24.3345C20.4411 24.7554 21.0987 25.7814 21.2829 26.781",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5748 25.4656C13.5748 24.8605 12.733 24.5185 12.1543 24.729C11.5755 24.9394 11.3388 25.7023 11.5755 26.2548C11.8123 26.8072 12.4436 27.3071 13.0487 27.3071",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0486 27.3071C12.6014 30.1746 12.9434 33.2525 13.9957 35.9621",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6793 41.7498C16.5738 43.223 18.2311 44.2227 19.9674 44.328",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2842 31.1742C18.7574 31.5688 20.3359 31.5951 21.8091 31.2005C22.2826 31.069 22.914 30.9637 23.2033 31.3583C23.3875 31.6477 23.3086 32.0423 23.0718 32.3054C22.835 32.5684 22.5193 32.7 22.2037 32.8315C20.7568 33.4366 19.3099 34.0154 17.8367 34.6204",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5743 36.1988C14.9429 35.7516 13.9959 35.8831 13.4171 36.4092C12.8384 36.9353 12.5753 37.7509 12.6016 38.5401C12.6542 39.987 14.0485 43.4333 15.6532 41.3813C16.5477 40.1975 16.9686 37.1722 15.5743 36.1988Z",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2821 16.4685C21.7037 21.1775 20.9934 25.9391 21.3091 30.9111",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1249 33.542C20.362 38.9086 20.5725 42.7495 20.9934 48.537",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9671 48.537C20.02 50.0102 19.3886 51.5624 18.4416 53.0356",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4679 53.0355C18.2838 51.878 16.679 50.589 15.5478 51.1677",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5478 51.1678C16.1002 53.8511 17.0999 56.0346 18.5994 58.3496",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5995 58.3232C21.9142 57.9812 25.2289 56.1397 27.6492 53.8247",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8602 53.0881C28.1489 53.7984 30.5955 53.9563 32.9632 53.6143",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3831 34.4101C35.1467 36.7251 33.1474 38.6718 31.8846 40.9868C31.6742 41.3815 31.4374 41.8287 31.49 42.2759C31.5953 43.0914 32.5423 43.5386 33.3578 43.4071C34.147 43.2756 34.3838 42.9073 35.0152 42.3811",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2823 16.4685C22.4931 16.3895 21.8617 15.4425 21.888 14.627C21.9143 13.8114 22.6246 13.1011 23.4401 13.0748C24.2556 13.0485 24.8344 13.7062 24.9133 14.4954",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9395 14.4956C27.465 12.8383 30.5167 12.5225 33.3841 13.4696",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M33.384 13.4696C33.6734 10.9967 38.4875 11.4176 35.6727 15.1006",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6201 15.1005C36.3303 16.337 37.9351 19.9411 38.3034 23.2295",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M28.149 18.0732C28.5436 18.0995 29.2275 18.0733 29.6221 18.0996C29.5169 17.8102 29.2012 17.5997 28.8855 17.5997C28.5698 17.5997 28.2805 17.7839 28.149 18.0732Z",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7277 18.3627C28.3594 19.7044 28.4383 21.1775 28.9644 22.4666",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0441 15.6793C27.0704 15.9424 27.0967 16.2055 27.123 16.4685",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M30.543 15.2847C30.5167 15.6267 30.4641 15.995 30.4378 16.337",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3311 37.2514C34.2784 34.5417 34.7256 32.9107 33.384 30.7272C32.3054 28.9383 30.727 27.6492 28.675 27.9912C27.5964 28.1753 26.0443 28.912 25.4655 29.8064C24.8867 30.7272 24.5711 31.7794 24.3343 32.858C23.7293 35.6729 23.624 38.5667 24.0186 41.4078C24.3343 43.7229 25.1236 46.1957 27.0966 47.4059C28.4909 48.274 30.3323 48.3529 31.7792 47.59C33.2261 46.8271 34.2258 45.275 34.3047 43.6177",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7842 27.4385C16.8631 26.9913 18.6257 26.1231 18.9151 26.281C19.2045 26.4388 19.1256 27.8858 18.731 28.2278C18.3364 28.5697 16.7053 27.9121 16.7842 27.4385Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8897 26.9125C16.1803 26.9125 16.4159 26.677 16.4159 26.3864C16.4159 26.0958 16.1803 25.8602 15.8897 25.8602C15.5991 25.8602 15.3636 26.0958 15.3636 26.3864C15.3636 26.677 15.5991 26.9125 15.8897 26.9125Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1523 25.8076C18.4429 25.8076 18.6784 25.572 18.6784 25.2814C18.6784 24.9908 18.4429 24.7553 18.1523 24.7553C17.8617 24.7553 17.6262 24.9908 17.6262 25.2814C17.6262 25.572 17.8617 25.8076 18.1523 25.8076Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2574 27.5964C18.2574 27.5964 18.8624 28.7277 18.9151 28.9644",
    stroke: "black",
    strokeWidth: 1.05229,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCards);
export default __webpack_public_path__ + "static/media/cards.a40bd86a1490c3343633d2b7f4829b11.svg";
export { ForwardRef as ReactComponent };